<template>
  <v-dialog v-model="dialogVisible" max-width="850px">
    <v-card class="pa-2">
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-file-document-multiple</v-icon>
        Quote Submissions for {{ customer?.name }} {{ customer?.lastName }}
      </v-card-title>
      <v-card-text>
        <div v-if="loading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else-if="quotes.length === 0" class="text-center py-8 text-medium-emphasis">
          No quotes found for this customer.
        </div>
        <v-data-table
          v-else
          :headers="headers"
          :items="quotes"
          :items-per-page="10"
          density="comfortable"
        >
          <template #item.dateCreated="{ item }">
            {{ formatDate(item.createdAt) }}
          </template>
          <template #item.eventDate="{ item }">
            {{ formatEventDate(item.event?.date) }}
          </template>
          <template #item.numberOfGuests="{ item }">
            {{ item.numberOfGuests }}
          </template>
          <template #item.menuName="{ item }">
            {{ item.menuName }}
          </template>
          <template #item.delivery="{ item }">
            {{ item.delivery }}
          </template>
          <template #item.totalCost="{ item }">
            ${{ formatCurrency(item.totalCost) }}
          </template>
          <template #item.actions="{ item }">
            <v-btn size="small" color="primary" variant="text" @click="viewQuote(item)">View Quote</v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { customerService } from '../services/customerService';
import { formatDate, formatEventDate, formatCurrency } from '../utils/index.js';

export default {
  name: 'CustomerQuotesModal',
  props: {
    customer: { type: Object, default: null },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      quotes: [],
      loading: false,
      headers: [
        { title: 'Date Created', value: 'dateCreated' },
        { title: 'Event Date', value: 'eventDate' },
        { title: 'Guests', value: 'numberOfGuests' },
        { title: 'Menu Name', value: 'menuName' },
        { title: 'Delivery', value: 'delivery' },
        { title: 'Total Cost', value: 'totalCost' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    show(newVal) {
      if (newVal && this.customer) {
        this.fetchCustomerQuotes();
      }
    },
  },
  methods: {
    async fetchCustomerQuotes() {
      this.loading = true;
      try {
        const response = await customerService.getCustomerQuotes(this.customer.id);
        this.quotes = response.data || [];
      } catch (err) {
        console.error('Failed to fetch customer quotes:', err);
        this.quotes = [];
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$emit('close');
    },
    viewQuote(quote) {
      this.$emit('view-quote', quote);
    },
    formatDate,
    formatEventDate,
    formatCurrency,
  },
};
</script>

<style scoped>
:deep(.v-data-table-header) {
  background-color: #f8fafc;
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
  color: #64748b !important;
}
</style> 